// extracted by mini-css-extract-plugin
export var configurationSection = "_s1-0";